<template>
  <div style="position: relative;">
    <template v-if="optionBotlist.length > 1">
      <v-btn
        style="
              height: 50px;
              min-width: 30px;
              padding:0;
              margin: 0;
              top: 50%;
              margin-top: -25px;
              right: -30px;
              z-index: 1 !important;
              position: absolute;
              border-radius: 0px 10px 10px 0px !important
            "
        @click="togglePagelist"
        color="primary"
      >
        <v-icon color="white--text" v-if="showPagelist"> keyboard_arrow_left</v-icon>
        <v-icon color="white--text" v-else> keyboard_arrow_right</v-icon>
      </v-btn>
    </template>
    <div
      id="livechat_pagelist"
      style="
      overflow-y: auto;
      border-right: 1px solid #eee;
      height: calc(100vh - 64px);
      position: relative;
    "
    >
      <!-- v-resize="onResizeToolList"
    :style="{ height: pagelistHeight + 'px' }" -->

      <div v-if="optionBotlist.length < 1 || showPagelist">
        <template v-for="(bot, bindex) in optionBotlist">
          <div :id="`bot_${bot.value}`" class="page" :key="`bot_${bindex}`">
            <v-badge v-model="bot.isLock" overlap color="info" style="">
              <template v-slot:badge>
                <v-icon dark small>lock</v-icon>
              </template>
              <div
                :key="`botcount_${bindex}_${timestamp}`"
                class="pa-2 img"
                :class="{
                  active: value == bot.value,
                  primary: value == bot.value,
                  islock: bot.isLock
                }"
                @click="selectPage(bot.value, bot.line_modular_botid)"
              >
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-avatar v-on="on">
                      <img
                        class="responsive-img circle"
                        style="min-width: 100%"
                        alt
                        @error="onError"
                        :src="
                          bot.pagelogo
                            ? bot.pagelogo
                            : 'https://graph.facebook.com/' +
                              bot.value +
                              '/picture?width=100&height=100&SameSite=None'
                        "
                      />

                      <div
                        style="right: 0px; top: 0px;"
                        class="newnotifycount"
                        v-if="
                          typeof $store.state.countAllNotiCustom[bot.value] !== 'undefined' &&
                            $store.state.countAllNotiCustom[bot.value] !== 0
                        "
                      >
                        {{ $store.state.countAllNotiCustom[bot.value] }}
                      </div>
                    </v-avatar>
                  </template>
                  <span>{{ bot.name }}</span>
                </v-tooltip>
              </div>
            </v-badge>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mounted } from '@chenfengyuan/vue-countdown'
import LivechatPagelist from './LivechatPagelist.js'

export default {
  mixins: [LivechatPagelist],
  data() {
    return {
      showPagelist: false,
      pageList: [],
      errImage: '@/static/assets/livechat/profile.png'
    }
  },
  methods: {
    togglePagelist() {
      const vm = this
      vm.showPagelist = !vm.showPagelist
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  .img {
    cursor: pointer;
    &.active {
      cursor: default;
    }

    &.islock {
      filter: grayscale(100%);
      // cursor: not-allowed;
    }
  }
}
</style>

<style lang="scss">
.page .v-badge--overlap .v-badge__badge {
  top: 1px;
  right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-pagelist.vue